import { Navigate, useParams } from 'react-router-dom';

/**
 * Redirect component for base whatsapp-send-message route
 * Redirects to /messages tab to ensure URL always has a tab
 */
export function WhatsAppSendMessageRedirect() {
  const { phoneNumber } = useParams<{ phoneNumber?: string }>();
  
  if (phoneNumber) {
    return <Navigate to={`/events/whatsapp-send-message/${phoneNumber}/messages`} replace />;
  }
  
  // Fallback if no phoneNumber
  return <Navigate to="/events/conversations" replace />;
}
